import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthSessionService } from '@features/auth/auth-session.service';
import { UiService } from '@shared/services/ui.service';
import { map } from 'rxjs';
import { AuthStore } from '@features/auth/auth.store';
import { AuthStatus } from '../models/models';
import { AuthApiService } from '../services/auth-api.service';

export const accessGuard: CanMatchFn = (_route, segments) => {
  const authStore = inject(AuthStore);
  const authSession = inject(AuthSessionService);
  const authApiService = inject(AuthApiService);
  const uiService = inject(UiService);
  const router = inject(Router);
  const returnUrl = router.getCurrentNavigation()?.extractedUrl.toString()
    ?? '/' + segments.map(segment => segment.path).join('/');

  if (authStore.authStatus() === AuthStatus.pending) {
    if (authStore.token()) {
      return authApiService.getAuthorization().pipe(
        map(response => {
          if (response.ok) {
            authStore.setAuthStatus(AuthStatus.passes);
          } else {
            authSession.expireSession(returnUrl);
          }
          uiService.stopLoading();
          return response.ok;
        }),
      );
    }

    authSession.expireSession(returnUrl);
    uiService.stopLoading();
    return false;
  }

  if (authStore.authStatus() === AuthStatus.passes) {
    return true;
  }

  authSession.expireSession(returnUrl);
  return false;
};
